import React from 'react';

const Promosi = () => {
  return (
    <h1>Promosi</h1>
  );
};

export default Promosi;





